module.exports = __webpack_public_path__ + "img/effects-21.2a19ad7a.png";